<template>

    <div class="testimonials-wrap">

        <div class="btns-wrap">
            <button :class="['btn btn-hollow', {active: selectedCategory == 'video'}]" @click="setCurrentTab('posts-video'), setCategory('video')">Video Testimonials</button>
            <button :class="['btn btn-hollow', {active: selectedCategory == 'text'}]" @click="setCurrentTab('posts-text'), setCategory('text')">Text Testimonials</button>
        </div>

        <div class="post-info" v-if="show_info === true && selectedCategory == 'video'">
            {{message}}
        </div>

        <div v-if="posts_paginated">

            <div class="posts-wrap">
                <keep-alive>
                    <transition name="slide">
                        <component v-bind:is="currentTabComponent" :selectedCategory="selectedCategory" :posts="posts_paginated"></component>
                    </transition>
                </keep-alive>
            </div>

            <b-pagination
                    v-model="current_page"
                    :total-rows="posts_filtered.length"
                    :per-page="posts_per_page"
                    ellipsis-text="..."
                    limit="5"
                    hide-ellipsis="false"
                    first-number
                    last-number
                    v-on:input="myPaginationClickedEventhandler"
            >
                <template v-slot:first-text><span class="page-first">First</span></template>
                <template v-slot:prev-text><span class="page-prev" v-html="arrow_left"></span></template>
                <template v-slot:next-text><span class="page-next" v-html="arrow_right"></span></template>
                <template v-slot:last-text><span class="page-last">Last</span></template>
                <template v-slot:ellipsis-text>
                    <div class="ellipsis-wrap">
                        <b-spinner small type="grow"></b-spinner>
                        <b-spinner small type="grow"></b-spinner>
                        <b-spinner small type="grow"></b-spinner>
                    </div>
                </template>
                <template v-slot:page="{ page, active }">
                    <b class="page-std page-std-hover" v-if="active">{{ page }}</b>
                    <i class="page-std" v-else>{{ page }}</i>
                </template>

            </b-pagination>

        </div>

    </div>

</template>

<script>
    import PostsVideo from './components/PostsVideo';
    import PostsText from './components/PostsText';
    import arrow_left from "./img/arrow-left";
    import arrow_right from "./img/arrow-right";

    export default {
        name: 'app',
        components: {
            PostsVideo,
            PostsText
        },
        data: () => (
            {
                current_page: 1,
                posts_per_page: 12,
                posts: [],
                posts_video: [],
                posts_text: [],
                show_pagination: true,
                show_info: false,
                message: 'Loading testimonials...',
                selectedCategory: "video",
                arrow_right: arrow_right,
                arrow_left: arrow_left,
                currentTab: "posts-video"
            }
        ),
        computed: {
            currentTabComponent: function () {
                return this.currentTab.toLowerCase();
            },
            posts_filtered: function () {

                if (this.currentTab == 'posts-text') {
                    this.posts_per_page = 6;
                    return this.posts_text;
                } else {
                    this.posts_per_page = 12;
                    return this.posts_video;
                }

            },
            posts_paginated: function () {

                return this.posts_filtered.filter((post, i) => {

                    if (
                        (i >= (this.current_page - 1) * this.posts_per_page) &&
                        (i < ((this.current_page) * this.posts_per_page))
                    ) {
                        return post;
                    }

                });

            }

        },
        methods: {
            setCurrentTab: function ($el) {
                return this.currentTab = $el;
            },
            setCategory: function ($el) {
                return this.selectedCategory = $el;
            },
            myPaginationClickedEventhandler: function () {
                jQuery("html, body").animate(
                    {scrollTop: '200px'},
                    1000
                )
            },
            getPostsVideo: function () {

                var self = this;

                var data = {
                    'action': 'my_action'
                };

                self.show_info = true;

                jQuery.ajax(
                    {
                        dataType: 'json',
                        data: data,
                        type: 'POST',
                        url: WPsettings.ajaxurl,

                    })
                    .done(function (data, textStatus, jqXHR) {

                        //console.log(data);
                        //console.log(textStatus);
                        //console.log(jqXHR.getAllResponseHeaders());

                        self.posts = data;
                        self.posts_video = data;

                        self.show_info = false;

                    })
                    .fail(function () {
                        console.error("REST error. Nothing returned for AJAX.");
                    })
                    .always(function () {

                    });

            },
            getPostsText: function () {

                var self = this;

                var data = {
                    'action': 'my_action_text'
                };

                //console.log(WPsettings);

                self.show_info = true;

                jQuery.ajax(
                    {
                        dataType: 'json',
                        data: data,
                        type: 'POST',
                        url: WPsettings.ajaxurl,

                    })
                    .done(function (data, textStatus, jqXHR) {

                        //console.log(data);
                        //console.log(textStatus);
                        //console.log(jqXHR.getAllResponseHeaders());

                        self.posts_text = data;

                        self.show_info = false;

                        //console.log(self.posts);

                    })
                    .fail(function () {
                        console.error("REST error. Nothing returned for AJAX.");
                    })
                    .always(function () {

                    });

            }

        },
        created() {
            this.getPostsVideo();
            this.getPostsText();
        },
        mounted: function () {

            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been rendered

            })
        }
    }

</script>

<style lang="scss">

    .slide-enter-active, .slide-leave-active {
        transition: opacity .7s ease;
    }

    .slide-enter, .slide-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .slide-leave-active,
    .slide-enter-active {
        transition: 0.7s;
    }

    .slide-enter {
        transform: translate(77%, 0);
    }

    .slide-leave-to {
        transform: translate(-77%, 0);
    }

    .testimonials-wrap {

        .post-info {
            color: #3f99f8;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 5px;
            line-height: 30px;
            text-transform: uppercase;
            text-align: center;
            padding-bottom: 25px;
        }

        .pagination {
            justify-content: center;
            flex-wrap: wrap;

            .page-item {
                margin-bottom: 10px;

                .page-link {
                    color: #84a4d7;
                    font-size: 19px;
                    font-weight: 700;
                    padding: 0;
                    margin: 0 5px;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    outline: 0;
                    cursor: pointer;
                    min-width: 35px;
                    height: 37px;
                    background-color: white;
                    border-radius: 6px;
                    border: 1px solid #c7c7c7;

                    .page-first {
                        display: inline-block;
                        padding-left: 25px;
                        padding-right: 25px;
                    }

                    .page-last {
                        display: inline-block;
                        padding-left: 25px;
                        padding-right: 25px;
                    }

                    .page-next {
                        svg {
                            width: 8px;
                            position: relative;
                            top: -2px;
                        }
                    }

                    .page-prev {
                        svg {
                            width: 8px;
                            position: relative;
                            top: -2px;
                        }
                    }

                    .page-std {

                    }

                }

                &.active {

                    .page-link {
                        z-index: 1;
                        border-radius: 6px;
                        border: 3px solid #6083bc;
                        background-color: #84a4d7;
                        font-size: 19px;
                        font-weight: 700;
                        color: #ffffff;
                    }

                }

                &.disabled:not(.bv-d-xs-down-none) {
                    display: none;
                }

            }

            .ellipsis-wrap {
                display: flex;
                width: 100%;
                justify-content: center;

                .spinner-grow {
                    display: block;
                    width: 3px;
                    height: 3px;
                    background: #6083bc;
                    margin: 0 2px;
                    border-radius: 50%;
                }

            }

        }

    }
</style>